import type { FaireProductEntity } from "../../entity_types/product";

export const p_2fjubzwjwq: FaireProductEntity = {
  token: "p_2fjubzwjwq",
  type: "product",
  name: "Croissant Catch-all Tray",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/09544679cc2c8a588f590ef4d318955314111eecab971bba997ba136bc703c2e.png",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "A vibrant metal tray perfect for trinkets, snacks, and more!\n\nA catch all for your desk and a perfect way to proudly display your croissant sticky notes and stationery. \n\nGood to know:\n-Measures 7\"x5.5\"\n-Durable metal tray\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:59.603Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
